export default "__VITE_ASSET__b74f32de__"